@if (translationViewer.isEnabled()) {
  <aside
    class="banner"
    role="status">
    <mat-icon class="banner-icon">visibility</mat-icon>
    <p class="banner-text">Translation key viewer is active</p>
    <coin-v2-button
      type="white"
      icon="visibility_off"
      text="Disable"
      (click)="translationViewer.toggle()"></coin-v2-button>
  </aside>
}
